import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '432px',
      height: '264px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      outline: `2px dashed #B1B1B1`,
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    iconContainer: {
      margin: '0 auto',
      paddingTop: '16px',
      order: 0,
      zIndex: 20,
    },

    textContainer: {
      textAlign: 'center',
      margin: '16px',
      order: 1,
    },

    buttonContainer: {
      margin: '0 auto',
      paddingTop: '52px',
      order: 2,
    },

    closeButton: {
      zIndex: 10,
      right: 0,
      top: 0,
      position: 'absolute',
    },
  },
  {
    name: 'UploadChosenFileModal',
  },
);
